import { useGetAPI } from '@api/useAPI';
import type { IFuelLevyHistoryEntry, APICallProps } from '@types';

export const useRateCardFuelLevyHistory = () => {
	const {
		isLoading,
		data,
		error,
		callAPI,
	} = useGetAPI({
		endpoint: '/api/lanes/{1}/fuel-levy/history',
		domain: 'ShipmentAPI',
	});

	const historyData = (data as { data: IFuelLevyHistoryEntry[] } | undefined)?.data;

	return {
		isLoading,
		data: historyData,
		error,
		callRateCardFuelLevyHistory: callAPI as (props?: APICallProps) => Promise<{ data: IFuelLevyHistoryEntry[] | null; error: null }>,
	};
};
